import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { ValueState } from "../state";
import { StatefulAccessor } from "./StatefulAccessor";
export var BaseQueryAccessor =
/*#__PURE__*/
function (_StatefulAccessor) {
  _inherits(BaseQueryAccessor, _StatefulAccessor);

  function BaseQueryAccessor(key) {
    var _this;

    _classCallCheck(this, BaseQueryAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseQueryAccessor).call(this, key));
    _this.state = new ValueState();
    return _this;
  }

  _createClass(BaseQueryAccessor, [{
    key: "keepOnlyQueryState",
    value: function keepOnlyQueryState() {
      this.setQueryString(this.getQueryString(), true);
    }
  }, {
    key: "setQueryString",
    value: function setQueryString(queryString) {
      var withReset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (withReset) {
        this.searchkit.resetState();
      }

      this.state = this.state.setValue(queryString);
    }
  }, {
    key: "getQueryString",
    value: function getQueryString() {
      return this.state.getValue();
    }
  }]);

  return BaseQueryAccessor;
}(StatefulAccessor);
export var NoopQueryAccessor =
/*#__PURE__*/
function (_BaseQueryAccessor) {
  _inherits(NoopQueryAccessor, _BaseQueryAccessor);

  function NoopQueryAccessor() {
    _classCallCheck(this, NoopQueryAccessor);

    return _possibleConstructorReturn(this, _getPrototypeOf(NoopQueryAccessor).apply(this, arguments));
  }

  _createClass(NoopQueryAccessor, [{
    key: "keepOnlyQueryState",
    value: function keepOnlyQueryState() {
      console.warn("keepOnlyQueryState called, No Query Accessor exists");
    }
  }, {
    key: "setQueryString",
    value: function setQueryString(_queryString) {
      var _withReset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      console.warn("setQueryString called, No Query Accessor exists");
    }
  }, {
    key: "getQueryString",
    value: function getQueryString() {
      console.warn("getQueryString called, No Query Accessor exists");
      return "";
    }
  }]);

  return NoopQueryAccessor;
}(BaseQueryAccessor);
export var noopQueryAccessor = new NoopQueryAccessor(null);